import React from 'react';
import { rowTotal, scoringRows, teams } from './gameTimelineData';
const MINUTES = Array.from({
  length: 40
}, (_, i) => i + 1);
const LEGEND = [{
  label: '1 point',
  home: 'bg-red-100 text-red-700',
  away: 'bg-blue-100 text-blue-700'
}, {
  label: '2 points',
  home: 'bg-red-300 text-red-900',
  away: 'bg-blue-300 text-blue-900'
}, {
  label: '3 points',
  home: 'bg-red-500 text-white',
  away: 'bg-blue-500 text-white'
}, {
  label: '4+ points',
  home: 'bg-red-700 text-white',
  away: 'bg-blue-700 text-white'
}];
const cellClasses = (points: number, team: 'home' | 'away') => {
  if (points <= 0) return 'bg-white text-transparent';
  const index = points >= 4 ? 3 : points - 1;
  return team === 'home' ? LEGEND[index].home : LEGEND[index].away;
};
const sortedRows = [...scoringRows].sort((a, b) => a.player.localeCompare(b.player));
export const ScoringTimeline = () => {
  return <div data-id="element-851" data-mp="pjb4pboacdor">
      {/* Legend */}
      <div className="flex flex-wrap items-center gap-x-8 gap-y-3 mb-5 p-4 bg-gray-50 border border-gray-200 rounded-lg" data-id="element-852" data-mp="25niz19rycnud">
        {(['home', 'away'] as const).map(side => <div key={side} className="flex items-center gap-3" data-id="element-853" data-mp="2aoosxaxcmh5h">
            <span className={`text-sm font-semibold ${side === 'home' ? 'text-red-600' : 'text-blue-600'}`} data-id="element-854" data-mp="2fkvyh2lu1qmw">
              {teams[side].name}
            </span>
            <div className="flex items-center gap-1.5" data-id="element-855" data-mp="2olc006j0mnp4">
              {LEGEND.map(step => <span key={step.label} title={step.label} className={`w-6 h-6 rounded flex items-center justify-center text-[10px] font-semibold border border-gray-200 ${side === 'home' ? step.home : step.away}`} data-id="element-856" data-mp="2tkooswtg64uc">
                  {step.label.charAt(0)}
                </span>)}
            </div>
          </div>)}
        <p className="text-xs text-gray-500" data-id="element-857" data-mp="3cczji3dy6whd">
          Darker cells mean more points scored in that minute
        </p>
      </div>

      {/* Heatmap */}
      <div className="overflow-x-auto border border-gray-200 rounded-lg" data-id="element-858" data-mp="1883de2nb6mvf">
        <table className="min-w-full border-collapse text-sm" data-id="element-859" data-mp="189xybgykyezi">
          <caption className="sr-only" data-id="element-860" data-mp="1m0jjxdff5313">
            Points scored minute by minute, by player
          </caption>
          <thead data-id="element-861" data-mp="1h7zwzpuucvjm">
            <tr className="bg-gray-50 text-xs text-gray-500" data-id="element-862" data-mp="1h7i2oyrqorec">
              <th scope="col" className="sticky left-0 z-20 bg-gray-50 px-3 py-2 text-left font-medium uppercase tracking-wider min-w-[180px]" data-id="element-863" data-mp="1vwmkwfyjavmg">
                Player
              </th>
              {MINUTES.map(minute => <th key={minute} scope="col" className={`w-8 px-0 py-2 text-center font-medium ${minute % 10 === 0 ? 'border-r border-gray-300' : ''}`} data-id="element-864" data-mp="20x1ztbygsb6j">
                  {minute}
                </th>)}
              <th scope="col" className="px-3 py-2 text-center font-medium uppercase tracking-wider border-l border-gray-300" data-id="element-865" data-mp="3sl9pwzp0jvm7">
                Tot
              </th>
            </tr>
          </thead>
          <tbody data-id="element-866" data-mp="3iskq522ts66p">
            {sortedRows.map(row => {
            const side = row.team as 'home' | 'away';
            const total = rowTotal(row);
            return <tr key={row.player} className="border-t border-gray-200" data-id="element-867" data-mp="38uwk3fzrrc98">
                  <th scope="row" className="sticky left-0 z-10 bg-white px-3 py-1.5 text-left font-medium text-gray-900 whitespace-nowrap" data-id="element-868" data-mp="3dw3qbam9k3ds">
                    <span className="flex items-center gap-2" data-id="element-869" data-mp="34vfdukciqb30">
                      <span className={`w-2 h-2 rounded-full ${side === 'home' ? 'bg-red-500' : 'bg-blue-500'}`} data-id="element-870" data-mp="y3mypclkfbt7" />
                      {row.player}
                      <span className="text-xs text-gray-400" data-id="element-871" data-mp="2z65r9c07g71w">
                        {teams[side].short}
                      </span>
                    </span>
                  </th>
                  {MINUTES.map(minute => {
                const points = row.minutes[minute] || 0;
                return <td key={minute} title={points > 0 ? `${row.player} — minute ${minute}: ${points} pts` : undefined} className={`w-8 h-8 text-center text-xs font-semibold border-r border-gray-100 ${minute % 10 === 0 ? 'border-r-gray-300' : ''} ${cellClasses(points, side)}`} data-id="element-872" data-mp="2l5l4y5v2zt3n">
                        {points > 0 ? points : ''}
                      </td>;
              })}
                  <td className="px-3 py-1.5 text-center font-bold text-gray-900 border-l border-gray-300" data-id="element-873" data-mp="1skbjpbvix0ud">
                    {total}
                  </td>
                </tr>;
          })}
          </tbody>
          <tfoot data-id="element-874" data-mp="h037efgg0xnv">
            {(['home', 'away'] as const).map(side => <tr key={side} className={`border-t-2 border-gray-300 ${side === 'home' ? 'bg-red-50' : 'bg-blue-50'}`} data-id="element-875" data-mp="lzpk8nsd0bw5">
                <th scope="row" className={`sticky left-0 z-10 px-3 py-2 text-left font-semibold whitespace-nowrap ${side === 'home' ? 'bg-red-50 text-red-700' : 'bg-blue-50 text-blue-700'}`} data-id="element-876" data-mp="3lge09qrkjjye">
                  {teams[side].name}
                </th>
                {MINUTES.map(minute => {
              const points = sortedRows.filter(row => row.team === side).reduce((sum, row) => sum + (row.minutes[minute] || 0), 0);
              return <td key={minute} className={`w-8 px-0 py-2 text-center text-xs font-semibold ${minute % 10 === 0 ? 'border-r border-gray-300' : ''} ${points > 0 ? 'text-gray-900' : 'text-gray-300'}`} data-id="element-877" data-mp="duwt3t8iy0tf">
                      {points > 0 ? points : '·'}
                    </td>;
            })}
                <td className="px-3 py-2 text-center font-bold text-gray-900 border-l border-gray-300" data-id="element-878" data-mp="3r2rl3rs78yzg">
                  {sortedRows.filter(row => row.team === side).reduce((sum, row) => sum + rowTotal(row), 0)}
                </td>
              </tr>)}
          </tfoot>
        </table>
      </div>
    </div>;
};
export default ScoringTimeline;